<template>
  <template v-if="loading">
    <teleport v-if="loadingVariant === 'fullscreen'" to="body">
      <div class="w-loading" :class="componentClasses">
        <slot>
          <w-loading-icon />

          <div v-if="loadingText" class="w-loading__text">
            {{ loadingText }}
          </div>
        </slot>
      </div>
    </teleport>

    <div v-else class="w-loading" :class="componentClasses">
      <slot>
        <w-loading-icon />

        <div v-if="loadingText" class="w-loading__text">
          {{ loadingText }}
        </div>
      </slot>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onBeforeUnmount, computed } from 'vue';

import { withLoadingProps } from '../../composables/props/loading';
import WLoadingIcon from '../w-assets/w-loading-icon/WLoadingIcon.vue';

// Komponent pokazujący ładowanie
export default defineComponent({
  components: { WLoadingIcon },

  props: {
    ...withLoadingProps
  },

  setup(props) {
    const componentName = 'w-loading';

    onBeforeMount(() => {
      if (props.loadingVariant === 'fullscreen') {
        document.body.classList.add('loading-visible');
      }
    });

    onBeforeUnmount(() => {
      if (props.loadingVariant === 'fullscreen') {
        document.body.classList.remove('loading-visible');
      }
    });

    /** Wyliczone klasy komponentu */
    const componentClasses = computed(() => {
      return `${componentName}--${props.loadingVariant}`;
    });

    return {
      componentClasses
    };
  }
});
</script>
<style lang="scss">
@use 'WLoading';
</style>
